import { SbsPlayerGlobal } from '../../../../../../common';
import { clamp } from '../../../../../../utils';

customElements.define(
  'sbs-player-repeat-section',
  class extends HTMLElement {
    constructor() {
      super();
      this.rendered = false;
      this.state = {
        dragging: false,
        startTime: 0,
        endTime: 0,
        duration: 0,
        startPercent: 0,
        endPercent: 30, // 초기값 30%
      };
    }

    set startTime(value) {
      this._startTime = value;
      this.updateDisplay();
    }
    get startTime() {
      return this._startTime || 0;
    }

    set endTime(value) {
      this._endTime = value;
      this.updateDisplay();
    }
    get endTime() {
      return this._endTime || 0;
    }

    set duration(value) {
      this._duration = value;
      this.updateDisplay();
    }
    get duration() {
      return this._duration || 0;
    }

    static get observedAttributes() {
      return [];
    }

    async attributeChangedCallback(name, oldValue, newValue) {
      try {
      } catch (error) {
        console.log(error);
      }
    }

    async connectedCallback() {
      try {
        this.render();
        this.setupRepeatMode();
      } catch (error) {
        console.log(error);
      }
    }

    setupRepeatMode() {
      // repeat toggle 이벤트 리스너
      SbsPlayerGlobal.events.addEventListener(
        'repeat-mode-changed',
        (enabled) => {
          if (enabled) {
            this.initializeRepeatSection();
            this.style.display = 'block';
            // repeat mode 활성화 시 progress bar 클릭 이벤트 차단
            this.style.pointerEvents = 'auto';
          } else {
            this.style.display = 'none';
            // repeat mode 비활성화 시 progress bar 클릭 이벤트 허용
            this.style.pointerEvents = 'none';
          }
        }
      );

      // 비디오 재생 시간 업데이트 리스너
      SbsPlayerGlobal.events.addEventListener(
        'video-change-player',
        (event) => {
          if (event.type === 'timeupdate' && event.target) {
            this.duration = event.target.duration || 0;

            // 구간 반복 체크
            this.checkRepeatPlayback(event.target);
          }
        }
      );
    }

    initializeRepeatSection() {
      // 현재 재생 시간을 기준으로 구간 설정
      const videoElement = SbsPlayerGlobal.view.querySelector('video');
      if (videoElement) {
        this.duration = videoElement.duration || 0;
        const currentTime = videoElement.currentTime || 0;

        // 시작: 현재 시간, 끝: 현재 시간 + 30초
        this.startTime = currentTime;
        let endTime = currentTime + 30;
        
        // 종료시간이 비디오 총 시간을 초과하면 비디오 종료시간으로 제한
        if (endTime > this.duration) {
          endTime = this.duration;
        }
        
        this.endTime = endTime;
        
        console.log(`구간 반복 설정: ${this.startTime.toFixed(1)}초 ~ ${this.endTime.toFixed(1)}초`);

        this.updateSectionDisplay();
        this.emitRepeatSectionChange();
      }
    }

    updateSectionDisplay() {
      if (!this.duration) return;

      this.state.startPercent = (this.startTime / this.duration) * 100;
      this.state.endPercent = (this.endTime / this.duration) * 100;

      const repeatDiv = this.querySelector('.playerSeekBar-repeat');
      const startHandle = this.querySelector('.start-handle');
      const endHandle = this.querySelector('.end-handle');

      if (repeatDiv) {
        const width = this.state.endPercent - this.state.startPercent;
        repeatDiv.style.left = `${this.state.startPercent}%`;
        repeatDiv.style.width = `${width}%`;
      }

      // 핸들 위치 설정 (Progress의 playerSeekBar-boll과 동일한 방식)
      if (startHandle) {
        startHandle.style.left = `0%`;
      }
      if (endHandle) {
        endHandle.style.left = `100%`;
      }
    }

    checkRepeatPlayback(videoElement) {
      // repeatMode가 활성화되어 있고, 구간을 벗어나면 시작 시간으로 이동
      const playerWrap = SbsPlayerGlobal.view.querySelector('.playerWrap');
      if (playerWrap && playerWrap.classList.contains('repeatMode-on')) {
        const currentTime = videoElement.currentTime;
        
        // 소수점 오차를 고려한 비교 (0.1초 여유)
        const tolerance = 0.1;
        const isBeforeStart = currentTime < (this.startTime - tolerance);
        const isAfterEnd = currentTime >= this.endTime;
        
        // 구간을 벗어난 경우 시작 시간으로 이동
        if (isBeforeStart || isAfterEnd) {
          console.log(`구간 반복: 현재 시간 ${currentTime.toFixed(2)}초가 구간(${this.startTime.toFixed(1)}~${this.endTime.toFixed(1)})을 벗어남 -> ${this.startTime.toFixed(1)}초로 이동`);
          // 시작 시간을 약간 뒤로 설정하여 반복적인 체크 방지
          videoElement.currentTime = this.startTime + 0.01;
        }
      }
    }

    emitRepeatSectionChange() {
      // center-repeat-text에 정보 전달
      const formatTime = (seconds) => {
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const secs = Math.floor(seconds % 60);

        if (hours > 0) {
          return `${hours.toString().padStart(2, '0')}:${minutes
            .toString()
            .padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
        } else {
          return `${minutes.toString().padStart(2, '0')}:${secs
            .toString()
            .padStart(2, '0')}`;
        }
      };

      const startText = formatTime(this.startTime);
      const endText = formatTime(this.endTime);

      SbsPlayerGlobal.events.emitEvent('repeat-section-changed', {
        startTime: this.startTime,
        endTime: this.endTime,
        startText: startText,
        endText: endText,
      });
    }

    render() {
      try {
        console.log('##### sbs-player-repeat-section 렌더링 시작');
        this.style.width = '100%';
        this.style.position = 'absolute';
        this.style.top = '0';
        this.style.height = '100%';
        this.style.pointerEvents = 'none';
        this.style.display = 'none'; // 초기에는 숨김

        this.innerHTML = `<div class="playerSeekBar-repeat">
            <button type="button" class="playerSeekBar-boll start-handle" data-handle="start"></button>
            <button type="button" class="playerSeekBar-boll end-handle" data-handle="end"></button>
        </div>`;

        console.log('##### sbs-player-repeat-section HTML 설정 완료');
        this.event();
        this.rendered = true;
        console.log('##### sbs-player-repeat-section 렌더링 완료');
      } catch (error) {
        console.log('##### sbs-player-repeat-section 렌더링 오류:', error);
      }
    }

    event() {
      const startHandle = this.querySelector('.start-handle');
      const endHandle = this.querySelector('.end-handle');
      const repeatDiv = this.querySelector('.playerSeekBar-repeat');
      const progressBar = this.closest('sbs-player-progressbar');

      if (!progressBar) return;

      // repeat section 영역에서 progress bar 클릭 이벤트 차단
      this.addEventListener('click', (e) => {
        e.stopPropagation();
        e.preventDefault();
      });

      if (repeatDiv) {
        repeatDiv.addEventListener('click', (e) => {
          e.stopPropagation();
          e.preventDefault();
        });
      }

      // 드래그 이벤트 처리
      [startHandle, endHandle].forEach((handle) => {
        if (!handle) return;

        let isDragging = false;
        let handleType = handle.dataset.handle;

        const startDrag = (e) => {
          isDragging = true;
          this.state.dragging = true;
          e.preventDefault();
          e.stopPropagation();

          // 마우스와 터치 이벤트 모두 지원
          const moveEvent = e.type.includes('mouse')
            ? 'mousemove'
            : 'touchmove';
          const endEvent = e.type.includes('mouse') ? 'mouseup' : 'touchend';

          const onMove = (moveE) => {
            if (!isDragging) return;

            const rect = progressBar.getBoundingClientRect();
            const clientX = moveE.type.includes('mouse')
              ? moveE.clientX
              : moveE.touches[0].clientX;
            const x = clientX - rect.left;
            const percent = clamp((x / rect.width) * 100, 0, 100);
            const time = (percent / 100) * this.duration;

            if (handleType === 'start') {
              // 시작점은 끝점보다 앞에 있어야 함
              if (time < this.endTime) {
                this.startTime = time;
              }
            } else {
              // 끝점은 시작점보다 뒤에 있어야 함
              if (time > this.startTime) {
                this.endTime = time;
              }
            }

            this.updateSectionDisplay();
            this.emitRepeatSectionChange();
          };

          const onEnd = () => {
            isDragging = false;
            // 약간의 딜레이 후 dragging 상태 해제 (클릭 이벤트와 구분하기 위함)
            setTimeout(() => {
              this.state.dragging = false;
            }, 100);
            document.removeEventListener(moveEvent, onMove);
            document.removeEventListener(endEvent, onEnd);
          };

          document.addEventListener(moveEvent, onMove);
          document.addEventListener(endEvent, onEnd);
        };

        handle.addEventListener('mousedown', startDrag);
        handle.addEventListener('touchstart', startDrag, { passive: false });

        // 핸들 클릭 시 해당 위치로 재생 시점 변경
        handle.addEventListener('click', (e) => {
          e.stopPropagation();
          e.preventDefault();
          
          // 드래그가 아닌 단순 클릭인 경우에만 재생 시점 변경
          if (!this.state.dragging) {
            const videoElement = SbsPlayerGlobal.view.querySelector('video');
            if (videoElement) {
              if (handleType === 'start') {
                console.log(`시작 핸들 클릭: ${this.startTime.toFixed(1)}초로 이동`);
                // 시작 시간에 약간의 오프셋 추가
                videoElement.currentTime = this.startTime + 0.01;
              } else {
                console.log(`종료 핸들 클릭: ${this.endTime.toFixed(1)}초로 이동`);
                // 종료 시간보다 약간 앞으로 설정
                videoElement.currentTime = this.endTime - 0.01;
              }
            }
          }
        });
      });
    }

    updateDisplay() {
      this.updateSectionDisplay();
    }
  }
);
